<template>
  <v-form @submit.prevent="submit">
    <div class="form-group film_something_now_enabled">
    </div>
    <fieldset style="border: 10px">
      <legend>{{ $t("settings.ftp") }}</legend>
      <v-text-field
        v-model="settings.ftp.host"
        label="Host"
        required
      ></v-text-field>
  
      <v-text-field
        v-model="settings.ftp.path"
        label="Path"
        required
      ></v-text-field>
  
      <v-text-field
        v-model="settings.ftp.user"
        label="User"
        required
      ></v-text-field>

      <v-text-field
        v-model="settings.ftp.password"
        :append-icon="showPwd ? 'visibility' : 'visibility_off'"
        :type="showPwd ? 'text' : 'password'"
        label="Password"
        class="input-group--focused"
        @click:append="showPwd = !showPwd"
        required
      ></v-text-field>
    </fieldset>
    <fieldset>
      <legend>{{ $t("settings.push_localization") }}</legend>
      <div class="form-group">
        <label>{{ $t("settings.push_thank_you") }}</label>
        <input-localized-textarea
          v-model="settings.localized_thank_you"
          :locales="locales"
          :current-locale="currentEditLocale"
          :attrs="{
            placeholder: $t('settings.push_thank_you'),
            maxlength: 100,
            name: 'push_thank_you',
            required: true,
            rows: 1,
            autofocus: false,
          }">
        </input-localized-textarea>
      </div>
      <div class="form-group">
        <label>{{ $t("settings.push_marker_request") }}</label>
        <input-localized-textarea
          v-model="settings.localized_marker_request"
          :locales="locales"
          :current-locale="currentEditLocale"
          :attrs="{
            placeholder: $t('settings.push_marker_request'),
            maxlength: 100,
            name: 'push_marker_request',
            required: true,
            rows: 1,
            autofocus: false,
          }">
        </input-localized-textarea>
      </div>
      <div class="locale-selection">
        <a
          v-for="l in locales" :key="l"
          :class="{'selected': l === currentEditLocale}"
          @click.stop.prevent="currentEditLocale = l"
          href="">
            <span v-if='l == "en"'>{{l}} (default)</span>
            <span v-else>{{l}}</span>
        </a>
      </div>
      <br/>
    </fieldset>
    <fieldset>
      <legend>{{ $t("settings.choose_export")}}</legend>
        <v-select
          v-model="settings.export_type"
          label="Export type"
          :items="exportTypes"
          single-line
          attach
          >
        </v-select>
    </fieldset>
    <fieldset>
      <legend>{{ $t("settings.choose_export_individual_format")}}</legend>
        <v-select
          v-model="settings.export_individual_format"
          label="Export individual format"
          :items="exportIndividualFormats"
          item-value='value'
          item-text='text'
          single-line
          attach
          >
        </v-select>
    </fieldset>
    <fieldset>
      <v-checkbox
        v-model="settings.film_something_now_enabled"
        label="Should the 'Film something now' button be enabled?">
      </v-checkbox>
    </fieldset>
    <fieldset style="border: 10px">
      <v-text-field
        v-model="settings.ios_app_version"
        label="iOS app version"
      ></v-text-field>
    </fieldset>
    <fieldset style="border: 10px">
      <legend>Video quality</legend>
      <div class="row">
        <div class="col-sm-4">
          <v-select
            v-model="settings.video_quality.wifi"
            label="WiFi"
            :items="videoQualityVariants"
            attach
          />
        </div>
        <div class="col-sm-4">
          <v-select
            v-model="settings.video_quality.mobile_4g"
            label="4G"
            :items="videoQualityVariants"
            attach
          />
        </div>
        <div class="col-sm-4">
          <v-select
            v-model="settings.video_quality.mobile_3g"
            label="3G"
            :items="videoQualityVariants"
            attach
          />
        </div>
      </div>
    </fieldset>
    <div class="form-group">
      <v-flex md3>
        <button type="submit"  class="btn btn-primary btn-full-width" :disabled="loading">{{ $t('save') }}</button>
      </v-flex>
    </div>
  </v-form>
</template>

<script>

import ConsumerSettingsRepository from '../../repositories/ConsumerSettingsRepository'
import InputLocalizedTextarea from '../markerEdit/InputLocalizedText.vue'

export default {
  components: {
    InputLocalizedTextarea
  },
  data () {
    let data = {
      loading: false,
      test: null,
      settings: {
        film_something_now_enabled: null,
        export_type: '',
        export_individual_format: '',
        localized_thank_you: {},
        localized_marker_request: {},
        ftp: {},
        ios_app_version: '',
        video_quality: {
          wifi: 'high',
          mobile_4g: 'medium',
          mobile_3g: 'medium',
        }
      },
      showPwd: false,
      exportTypes: ['CSV', 'XML'],
      exportIndividualFormats: [{value: 1, text: 'Id'},
                                {value: 2, text: 'Country-City-Date'}],
      currentEditLocale: 'en',
      locales: ['en', 'fr', 'nl'],
      videoQualityVariants: [
        { value: 'high', text: 'High' },
        { value: 'medium', text: 'Medium' },
        { value: 'low', text: 'Low' },
      ]
    }
    data.locales.forEach(function (l) {
      data.settings.localized_thank_you[l] = ''
      data.settings.localized_marker_request[l] = ''
    })
    return data
  },
  mounted () {
    this.loading = true
    ConsumerSettingsRepository.fetchSettings().then(
      (settings) => {
        this.loading = false
        if (settings.ftp === null) {
          settings.ftp = {
            host: '',
            path: '',
            user: '',
            password: ''
          }
        }
        if (!settings.video_quality) {
          settings.video_quality = this.settings.video_quality
        }
        this.settings = settings
      }
    )
  },
  methods: {
    async submit () {
      console.log('test')
      let payload = JSON.parse(JSON.stringify(this.settings))
      if (this.isEmpty(payload.ftp)) {
        delete payload.ftp
      }
      try {
        await ConsumerSettingsRepository.patchSettings(payload)
        this.$store.commit('snackbar/show', {
          message: 'The settings have been updated', color: 'green'
        })
      } catch (error) {
        this.notifyError(error)
      }
    },
    isEmpty (obj) {
      return Object.values(obj).every(x => (x === null || x === ''))
    },
    async notifyError (error) {
      const { response } = error
      let json
      try {
        json = await response.json()
      } catch (e) {
        json = {}
      }
      const { non_field_errors: nonFieldErrors, ftp } = json
      let message
      if (ftp) {
        let errList = Object.entries(ftp).map(
          function (err) {
            return err[0] + ': ' + err[1]
          }
        )
        message = errList.join(' ')
      }
      message = nonFieldErrors || message || 'Hello'
      this.$store.commit('snackbar/show', { message, color: 'error' })
    }
  }

}
</script>



// WEBPACK FOOTER //
// ConsumerSettings.vue?e149d512